import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createCombineReducers } from 'mt-react-common/modules/comments/reducers/form/combine';
import { createCombineName } from 'mt-react-common/modules/comments/reducers/form/naming';
import CommentChildForm from '../../CommentChildForm';

class CommentChildFormRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: createCombineName(
        `${this.props.modelClass}-${this.props.modelId}-${this.props.parentId}`
      )
    };
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <CommentChildForm {...this.props} reducerName={this.state.reducerName} />
    );
  }
}

CommentChildFormRWrapper.propTypes = {
  modelClass: PropTypes.number.isRequired,
  modelId: PropTypes.number.isRequired,
  parentId: PropTypes.number.isRequired,
  listReducerName: PropTypes.string.isRequired,
  hideSubForm: PropTypes.func.isRequired
};

export default CommentChildFormRWrapper;



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentChildFormRWrapper/CommentChildFormRWrapper.js